import React from 'react'
import FormattedPrice from '@components/FormattedPrice'
import _round from 'lodash/round'
import AfterPayButton from '@components/AfterPayInfo/AfterPayButton'
import { Trans } from 'react-i18next'

const AFTERPAY_PAYMENTS_COUNT = 4

interface Props {
  minPrice: number
  maxPrice: number
  currency: string
}
const AfterPayInfo: React.FC<Props> = ({ minPrice, maxPrice, currency }) => {
  if (currency !== 'USD') return null
  return (
    <div className='flex items-center flex-wrap'>
      <span>
        {minPrice !== maxPrice ? (
          <Trans
            i18nKey='afterPayInfoPaymentsPrice'
            defaults={`or {{paymentsCount}} payments of <min/> - <max/> with`}
            values={{
              paymentsCount: AFTERPAY_PAYMENTS_COUNT,
            }}
            components={{
              min: <FormattedPrice amount={_round(minPrice / AFTERPAY_PAYMENTS_COUNT, 2)} currency={currency} />,
              max: <FormattedPrice amount={_round(maxPrice / AFTERPAY_PAYMENTS_COUNT, 2)} currency={currency} />,
            }}
          />
        ) : (
          <Trans
            i18nKey='afterPayInfoPaymentsPriceRange'
            defaults={`or {{paymentsCount}} payments of <min/> with`}
            values={{
              paymentsCount: AFTERPAY_PAYMENTS_COUNT,
            }}
            components={{
              min: <FormattedPrice amount={_round(minPrice / AFTERPAY_PAYMENTS_COUNT, 2)} currency={currency} />,
            }}
          />
        )}
      </span>
      <AfterPayButton />
    </div>
  )
}

export default AfterPayInfo
